const ordersSubMenu = [
  {
    submenu: "Create",
    id: 101,
    path: "/ofp/orders/create",
    icon: "CreateImage"
  },
  {
    submenu: "FTP",
    id: 102,
    path: "/ofp/orders/autoLog",
    icon: "FtpImage"
  },
  {
    submenu: "Website",
    id: 108,
    path: "/ofp/orders/webSite",
    icon: "sevenElevenImage"
  },
  {
    submenu: "Excel",
    id: 103,
    path: "/ofp/orders/excelorders",
    icon: "ExcelImage"
  },
  {
    submenu: "Email",
    id: 104,
    path: "/ofp/orders/emailBodyOrders",
    icon: "EmailImage"
  },
  {
    submenu: "PDF",
    id: 105,
    path: "/ofp/orders/pdfOrders",
    icon: "PdfImage"
  },
  {
    submenu: "Phone",
    id: 106,
    path: "/ofp/orders/phoneorders",
    icon: "PhoneImage"
  },
  {
    submenu: "API",
    id: 107,
    path: "/ofp/orders/apiorders",
    icon: "ApiImage"
  }
];

const orderSummarySubMenu = [
  {
    submenu: "Manual",
    id: 201,
    path: "/ofp/ordersSummary/logsummary",
    icon: "CreateSummaryImage"
  },
  {
    submenu: "Duplicated",
    id: 202,
    path: "/ofp/ordersSummary/duplicate-orders-summary",
    icon: "DuplicateOrdersSummaryImage"
  },
  {
    submenu: "Order Restaging",
    id: 203,
    path: "/ofp/ordersSummary/orderRestaging",
    icon: "RestageOrderImage"
  }
];

const utilitiesSubMenu = [
  {
    submenu: "Switchboard Routing",
    id: 301,
    path: "/ofp/utilities/edipurchaseorder",
    icon: "SwitchboardRoutingImage"
  },
  {
    submenu: "Currency Conversion",
    id: 302,
    path: "/ofp/utilities/currencyconversion",
    icon: "CurrencyImage"
  },
  {
    submenu: "Specright",
    id: 303,
    path: "/ofp/utilities/specright",
    icon: "SpecrightImage"
  },
  {
    submenu: "Region Mappings",
    id: 304,
    path: "/ofp/utilities/regionMappings",
    icon: "RegionMappingsImage"
  },
  //INFO: Remove Baja , Rename url and title as Duplicate orders
  {
    submenu: "Duplicate orders",
    id: 305,
    path: "/ofp/utilities/duplicate-orders",
    icon: "BajaOrdersImage"
  },
  {
    submenu: "PO Invoice",
    id: 306,
    path: "/ofp/utilities/purchaseOrderInvoice",
    icon: "POInvoiceImage"
  },
  {
    submenu: "PO Creation",
    id: 307,
    path: "/ofp/utilities/purchaseOrderCreation",
    icon: "POCreationImage"
  },
  {
    submenu: "SO Picking",
    id: 308,
    path: "/ofp/utilities/salesOrdersPicking",
    icon: "SOPickingImage"
  }
];

const administrationSubMenu = [
  {
    submenu: "Function Setup",
    id: 401,
    path: "/ofp/administration/function",
    icon: "FunctionSetupImage"
  },
  {
    submenu: "ItemXref",
    id: 402,
    path: "/ofp/administration/itemXref",
    icon: ""
  },
  {
    submenu: "ShipToXref",
    id: 403,
    path: "/ofp/administration/shipToxref",
    icon: ""
  },
  {
    submenu: "Entity",
    id: 404,
    path: "/ofp/administration/entitySearch",
    icon: ""
  },
  {
    submenu: "Staging Configs",
    id: 405,
    path: "/ofp/administration/order-flow",
    icon: "OrderConfigImage"
  },
    {
    submenu: "Item/Store Xref",
    id: 406,
    path: "/ofp/administration/ItemAndStoreDetails",
    icon: "ItemOrShipXrefImage"
  },
  {
    submenu: "Kroger Retail",
    id: 407,
    path: "/ofp/administration/KrogerRetail",
    icon: "KrogerInvoiceImage"
  }
];

const userManagementSubMenu = [
  {
    submenu: "Users",
    id: 501,
    path: "/ofp/UserManagement/Users",
    icon: "pi pi-users"
  }
];

const invoicesSubMenu = [
  {
    submenu: "Credit Invoices",
    id: 601,
    path: "/ofp/invoices/credit-invoices",
    icon: "CreateCreditInvoicesImage"
  }
];

export const sidemenu = (
  showAutoLog,
  showSwitchboardWalmartOrders,
  showSwitchboardSamsClubOrders,
  showSwitchboardTraderJoesOrders,
  showItemXref,
  ShowShipToXref,
  showEntity,
  showUsers,
  showEmailOrders,
  showPdfOrders,
  showCurrencyConversion,
  showExcelOrders,
  showApiOrders,
  showPhoneOrders,
  showSpecright,
  showWalmartRegionMappings,
  showSamsClubRegionMappings,
  showTraderJoesRegionMappings,
  showBajaOrders,
  showPOInvoice,
  showPOCreate,
  showSOPick,
  // TODO: Add new param for credit invoice flag
  //showCreditInvoice (info:Hardcoding as true)
  //TODO:Add new param for duplicate order flag
  //showDuplicateOrders
  showDuplicateOrdersSummary,
  //TODO:Add new param for SevenEleven ordersflag
  //showWebSiteOrders
  showOrderConfig,
  showItemOrStoreDetails,
  showOrderActionConfig,
  showOrderRestaging
) => {
  let filteredSubMenu = [...ordersSubMenu];
  let filteredOrderSummarySubMenu = [...orderSummarySubMenu];
  let filteredUtilitiesSubMenu = [...utilitiesSubMenu];
  let filteredAdministrationSubMenu = [...administrationSubMenu];
  let filteredUserManagementSubMenu = [...userManagementSubMenu];
  let filteredInvoicesSubMenu = [...invoicesSubMenu];

  if (!showAutoLog) {
    filteredSubMenu = filteredSubMenu.filter((item) => item.id !== 102);
  }
  if (!showExcelOrders) {
    filteredSubMenu = filteredSubMenu.filter((item) => item.id !== 103);
  }
  if (!showEmailOrders) {
    filteredSubMenu = filteredSubMenu.filter((item) => item.id !== 104);
  }
  if (!showPdfOrders) {
    filteredSubMenu = filteredSubMenu.filter((item) => item.id !== 105);
  }
  if (!showPhoneOrders) {
    filteredSubMenu = filteredSubMenu.filter((item) => item.id !== 106);
  }
  if (!showApiOrders) {
    filteredSubMenu = filteredSubMenu.filter((item) => item.id !== 107);
  }
  // TODO: use showWebSiteOrders params
  //TODO: remove hard-coded boolen value
  if (false) {
    filteredSubMenu = filteredSubMenu.filter((item) => item.id !== 108);
  }

  //Info : false flag will help in showing menu item on left nav bar
  //TODO: use showCreditInvoice param
  //TODO: remove hard-coded boolen value
  if (false) {
    filteredInvoicesSubMenu = filteredInvoicesSubMenu.filter(
      (item) => item.id !== 601
    );
  }

  if (!showSwitchboardWalmartOrders && !showSwitchboardSamsClubOrders && !showSwitchboardTraderJoesOrders) {
    filteredUtilitiesSubMenu = filteredUtilitiesSubMenu.filter(
      (item) => item.id !== 301
    );
  }
  if (!showCurrencyConversion) {
    filteredUtilitiesSubMenu = filteredUtilitiesSubMenu.filter(
      (item) => item.id !== 302
    );
  }
  if (!showSpecright) {
    filteredUtilitiesSubMenu = filteredUtilitiesSubMenu.filter(
      (item) => item.id !== 303
    );
  }
  if (
    !showWalmartRegionMappings &&
    !showSamsClubRegionMappings &&
    !showTraderJoesRegionMappings
  ) {
    filteredUtilitiesSubMenu = filteredUtilitiesSubMenu.filter(
      (item) => item.id !== 304
    );
  }
  //Use: enableDuplicateOrders falg remove showBajaOrders flag : !showBajaOrders
  if (false) {
    filteredUtilitiesSubMenu = filteredUtilitiesSubMenu.filter(
      (item) => item.id !== 305
    );
  }

  if (!showPOCreate) {
    filteredUtilitiesSubMenu = filteredUtilitiesSubMenu.filter(
      (item) => item.id !== 307
    );
  }
  if (!showSOPick) {
    filteredUtilitiesSubMenu = filteredUtilitiesSubMenu.filter(
      (item) => item.id !== 308
    );
  }

  // Use: showDuplicateOrdersSummary
  if (!showDuplicateOrdersSummary) {
    filteredOrderSummarySubMenu = filteredOrderSummarySubMenu.filter(
      (item) => item.id !== 202
    );
  }
  if(!showOrderRestaging) {
    filteredOrderSummarySubMenu = filteredOrderSummarySubMenu.filter(
      (item) => item.id !== 203
    );
  }

  if (!showItemXref) {
    filteredAdministrationSubMenu = filteredAdministrationSubMenu.filter(
      (item) => item.id !== 402
    );
  }
  if (!ShowShipToXref) {
    filteredAdministrationSubMenu = filteredAdministrationSubMenu.filter(
      (item) => item.id !== 403
    );
  }
  if (!showEntity) {
    filteredAdministrationSubMenu = filteredAdministrationSubMenu.filter(
      (item) => item.id !== 404
    );
  }

  if (!showOrderConfig) {
    filteredAdministrationSubMenu = filteredAdministrationSubMenu.filter(
      (item) => item.id !== 405
    );
  }

  if (!showItemOrStoreDetails) {
    filteredAdministrationSubMenu = filteredAdministrationSubMenu.filter(
      (item) => item.id !== 406
    );
  }

  if (!showOrderActionConfig) {
    filteredAdministrationSubMenu = filteredAdministrationSubMenu.filter(
      (item) => item.id !== 407
    );
  }

  if (!showUsers) {
    filteredUserManagementSubMenu = filteredUserManagementSubMenu.filter(
      (item) => item.id !== 501
    );
  }

  const menu = [
    {
      heading: "Orders",
      id: 1,
      icon: "Orders",
      path: "/ofp/orders/create",
      routePath: "/ofp/orders/create",
      isExpanded: true,
      showSubMenuFlag: false,
      menuItems: filteredSubMenu
    },
    {
      heading: "Order Summary",
      id: 2,
      icon: "orderSummary",
      path: "/ofp/ordersSummary/logsummary",
      routePath: "/ofp/ordersSummary/logsummary",
      isExpanded: true,
      showSubMenuFlag: false,
      menuItems: filteredOrderSummarySubMenu
    },
    {
      heading: "Utilities",
      id: 3,
      icon: "admin",
      path: "/ofp/utilities/duplicate-orders",
      routePath: "/ofp/utilities/duplicate-orders",
      isExpanded: true,
      showSubMenuFlag: false,
      menuItems: filteredUtilitiesSubMenu
    },
    {
      heading: "Administration",
      id: 4,
      icon: "user",
      path: "/ofp/administration/function",
      routePath: "/ofp/administration/function",
      isExpanded: true,
      showSubMenuFlag: false,
      menuItems: filteredAdministrationSubMenu
    },
    {
      heading: "User Management",
      id: 5,
      icon: "customer",
      path: "/ofp/UserManagement",
      routePath: "/ofp/UserManagement",
      isExpanded: true,
      showSubMenuFlag: false,
      menuItems: filteredUserManagementSubMenu
    },
    {
      heading: "Invoices",
      id: 6,
      icon: "Invoices",
      path: "/ofp/invoices/credit-invoices",
      routePath: "/ofp/invoices/credit-invoices",
      isExpanded: true,
      showSubMenuFlag: false,
      menuItems: filteredInvoicesSubMenu
    }
  ];

  return menu;
};
